import {SET_CONTRACT_MODE, SET_MAX_RECURRING} from "../actionTypes/index";

export const setContractMode = value => dispatch => {
  dispatch({ type: SET_CONTRACT_MODE, payload: value });
};

export const setMaxRecurring = value => dispatch => {
  dispatch({ type: SET_MAX_RECURRING, payload: value });
};
